import * as Types from './usersActionTypes';

export function login(email, password, staySignedIn, onFail) {
  return { type: Types.LOGIN, email, password, staySignedIn, onFail };
}

export function logout() {
  return { type: Types.LOGOUT };
}

export function loginSuccess({ token, institution }) {
  return { type: Types.LOGIN_SUCCESS, token, institution };
}

export function loginFailure({ error }) {
  return { type: Types.LOGIN_FAILURE, error };
}

export function refreshToken(password, onSuccess, onFail) {
  return { type: Types.REFRESH_TOKEN, password, onSuccess, onFail };
}

export function refreshTokenSuccess() {
  return { type: Types.REFRESH_TOKEN_SUCCESS };
}

export function refreshTokenFailure(error) {
  return { type: Types.REFRESH_TOKEN_FAILURE, error };
}

export function register(user, onSuccess, onFail) {
  return { type: Types.REGISTER, user, onSuccess, onFail };
}

export function registerSuccess(user) {
  return { type: Types.REGISTER_SUCCESS, user };
}

export function registerFailure(error) {
  return { type: Types.REGISTER_FAILURE, error };
}

export function getUser() {
  return { type: Types.GET_USER };
}

export function getUserSuccess(user) {
  return { type: Types.GET_USER_SUCCESS, user };
}

export function getUserFailure(error) {
  return { type: Types.GET_USER_FAILURE, error };
}

export function invite(data, onSuccess, onFail) {
  return { type: Types.INVITE, data, onSuccess, onFail };
}

export function inviteSuccess() {
  return { type: Types.INVITE_SUCCESS };
}

export function inviteFailure(error) {
  return { type: Types.INVITE_FAILURE, error };
}

export function getUsers() {
  return { type: Types.GET_USERS };
}

export function getUsersSuccess(users) {
  return { type: Types.GET_USERS_SUCCESS, users };
}

export function getUsersFailure(error) {
  return { type: Types.GET_USERS_FAILURE, error };
}

export function updateUser(data, onSuccess = () => undefined, onFail = () => undefined) {
  return { type: Types.UPDATE_USER, data, onSuccess, onFail };
}

export function updateUserSuccess(user) {
  return { type: Types.UPDATE_USER_SUCCESS, user };
}

export function updateUserFailure(error) {
  return { type: Types.UPDATE_USER_FAILURE, error };
}

export function resetPassword(email, onSuccess = () => undefined, onFail = () => undefined) {
  return { type: Types.RESET_PASSWORD, email, onSuccess, onFail };
}

export function resetPasswordSuccess(data) {
  return { type: Types.RESET_PASSWORD_SUCCESS, data };
}

export function resetPasswordFailure(error) {
  return { type: Types.RESET_PASSWORD_FAILURE, error };
}

export function setPassword(data, onFail) {
  return { type: Types.SET_PASSWORD, data, onFail };
}

export function setPasswordSuccess({ token, institution }) {
  return { type: Types.SET_PASSWORD_SUCCESS, token, institution };
}

export function setPasswordFailure(error) {
  return { type: Types.SET_PASSWORD_FAILURE, error };
}

export function welcome(data, onFail) {
  return { type: Types.WELCOME, data, onFail };
}

export function welcomeSuccess({ token, institution }) {
  return { type: Types.WELCOME_SUCCESS, token, institution };
}

export function welcomeFailure(error) {
  return { type: Types.WELCOME_FAILURE, error };
}

export function join(data, onFail) {
  return { type: Types.JOIN, data, onFail };
}

export function joinSuccess({ token, institution }) {
  return { type: Types.JOIN_SUCCESS, token, institution };
}

export function joinFailure(error) {
  return { type: Types.JOIN_FAILURE, error };
}

export function changePassword(data, onSuccess, onFail) {
  return { type: Types.CHANGE_PASSWORD, data, onSuccess, onFail };
}

export function changePasswordSuccess(data) {
  return { type: Types.CHANGE_PASSWORD_SUCCESS, data };
}

export function changePasswordFailure(error) {
  return { type: Types.CHANGE_PASSWORD_FAILURE, error };
}

export function getJoinData(token, onSuccess, onFail) {
  return { type: Types.GET_JOIN_DATA, token, onSuccess, onFail };
}

export function getJoinDataSuccess(data) {
  return { type: Types.GET_JOIN_DATA_SUCCESS, data };
}

export function getJoinDataFailure(error) {
  return { type: Types.GET_JOIN_DATA_FAILURE, error };
}

export function getWelcomeData(token, onSuccess, onFail) {
  return { type: Types.GET_WELCOME_DATA, token, onSuccess, onFail };
}

export function getWelcomeDataSuccess(data) {
  return { type: Types.GET_WELCOME_DATA_SUCCESS, data };
}

export function getWelcomeDataFailure(error) {
  return { type: Types.GET_WELCOME_DATA_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/redux/actions/usersActions.js